module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-mad-evil-svgrepo-com.c68a2aea.svg";